import { AlertVM } from '../types/alerts'

let alerts: AlertVM[] = [
  {
    id: 'alert-needs-based',
    title: 'Atlas Labs',
    accountName: 'Atlas Labs',
    featureName: 'Advanced Analytics',
    featureStatus: 'GA',
    opportunityValue: 240000,
    actionRecommendation: 'Confirm fit during Apr 18 QBR prep and share RevOps workflow deck.',
    matchType: 'Needs Match',
    opportunityType: 'Expansion',
    priority: 'High',
    status: 'New',
    createdAt: '2025-11-11T14:05:00Z',
    matchConfidencePct: 87,
    summary: 'Exec team repeatedly flagged manual reporting delays; Advanced Analytics solves the gap.',
    badges: [
      { label: 'Weighted Pipeline $240K', color: 'blue' },
      { label: 'Account Health: Strong', color: 'green' },
      { label: 'Meeting in 7 days', color: 'orange' },
    ],
    sections: [
      {
        id: 'customer-needs',
        title: 'Needs & Pain Points',
        highlight: {
          text: '“We can’t get regional reporting out in time for QBRs.”',
          chips: [
            { label: 'Reporting & Analytics', tone: 'primary' },
            { label: 'Executive Visibility', tone: 'secondary' },
          ],
        },
        items: [
          { label: 'Impact', value: 'Delayed executive visibility; renewal flagged as at risk.', tone: 'negative' },
          { label: 'Sentiment', value: 'Very Negative', tone: 'negative', trendChip: { label: '↘', tone: 'negative' } },
          { label: 'Severity', value: 'High', tone: 'negative', trendChip: { label: '↘', tone: 'negative' } },
          { label: 'Mentions', value: '3 times, last mentioned 5 days ago in QBR prep call' },
        ],
      },
      {
        id: 'relevant-engagements',
        title: 'Relevant Engagements',
        engagements: [
          {
            date: 'Apr 10',
            type: 'Gong Call',
            description: 'CFO escalated reporting delays; AE committed to follow-up before Apr 18.',
            url: 'https://app.gong.io/calls/12345',
          },
          {
            date: 'Apr 07',
            type: 'Email',
            description: 'Analytics manager requested automation benchmarks for dashboards.',
            url: 'https://salesforce.com/email/67890',
  },
  {
            date: 'Apr 02',
            type: 'Support Ticket',
            description: 'Requested dashboard export for board deck due to manual effort.',
            url: 'https://salesforce.com/case/11111',
          },
        ],
        collapsible: true,
        defaultOpen: false,
      },
      {
        id: 'feature-fit',
        title: 'Feature Fit',
        items: [
          { label: 'Eligibility', value: '✅ Enterprise tier meets requirements.', tone: 'positive' },
          { label: 'Overview', value: 'Advanced Analytics automates regional dashboards, board packs, and executive scorecards.' },
          { label: 'Use Cases', value: 'Quarterly business reviews; regional dashboards; CRO scorecards.' },
          { label: 'Benefits', value: 'Cuts manual prep by 10+ hours per QBR; surfaces leading indicators for execs.' },
          { label: 'Requirements', value: 'SSO integration (Okta/G Suite); Data warehouse connector.' },
          { label: 'Warnings', value: 'Enablement requires 2-week guided rollout with RevOps.' },
        ],
        link: { label: 'View Documentation', href: 'https://docs.example.com/analytics' },
      },
      {
        id: 'outcomes',
        title: 'Expected Outcomes & Proof',
        items: [
          { label: 'Benefits', value: 'Exec-ready dashboards in minutes; stronger renewal signal; ROI realized in <60 days.' },
        ],
        bullets: [
          'TechCorp – Reduced reporting cycle 40%; exec adoption 95% | https://example.com/case-techcorp',
          'DataFlow Inc – Saved $4K/month removing manual reporting scripts | https://example.com/case-dataflow',
        ],
      },
      {
        id: 'health-signals',
        title: 'Health & Pipeline Signals',
        items: [
          { label: 'Account Health', value: 'Strong • trending up', tone: 'positive' },
          { label: 'Weighted Pipeline', value: '$240K expansion opportunity' },
          { label: 'Open Opportunities', value: '2 opportunities • closest stage: Negotiation' },
          { label: 'Engagement Velocity', value: '+12% in last 14 days', tone: 'positive' },
        ],
      },
      {
        id: 'actions',
        title: 'Next Steps',
        bullets: [
          'Confirm fit during Apr 18 QBR prep call (2:00 PM). Bring analytics workflow deck.',
          'Schedule RevOps working session to scope dashboard rollout before June.',
          'Share TechCorp proof point with CFO and RevOps ahead of meeting.',
        ],
        items: [
          { label: 'Owner', value: 'Account Executive' },
          { label: 'Timing', value: 'Complete by Apr 19 to stay ahead of QBR.' },
        ],
      },
    ],
  },
  {
    id: 'alert-target-match',
    title: 'Nimbus Retail',
    accountName: 'Nimbus Retail',
    featureName: 'Customer Journeys',
    featureStatus: 'GA',
    opportunityValue: 90000,
    actionRecommendation: 'Introduce journey orchestration during May 3 QBR; prep case studies.',
    matchType: 'Ideal Profile',
    opportunityType: 'Upsell',
    priority: 'Medium',
    status: 'Opened',
    createdAt: '2025-11-10T18:30:00Z',
    matchConfidencePct: 80,
    summary: 'Mid-market retail ICP match with loyalty program expansion plans.',
    badges: [
      { label: 'ICP Score 0.84', color: 'blue' },
      { label: 'Weighted Pipeline $310K', color: 'blue' },
      { label: 'Win Rate 52%', color: 'green' },
    ],
    sections: [
      {
        id: 'customer-context',
        title: 'Fit Statement',
        items: [
          { label: 'Why it fits', value: 'High-growth loyalty program, strong ecommerce performance, and dedicated marketing ops team.' },
          { label: 'Strategic Goal', value: 'Increase repeat purchase frequency and unify omnichannel experiences.' },
          { label: 'Eligibility', value: '✅ Meets tier; marketing automation + SSO integrations already active.', tone: 'positive' },
          { label: 'Stakeholders', value: 'VP Marketing, Loyalty Director, Martech Lead' },
        ],
      },
      {
        id: 'icp-signals',
        title: 'Ideal Customer Profile Signals',
        items: [
          { label: 'Segment', value: 'Mid-market retail (75 stores)' },
          { label: 'Growth', value: 'Forecast +24% loyalty revenue YoY' },
          { label: 'Tech Stack', value: 'Salesforce Commerce, Klaviyo, Segment' },
        ],
      },
      {
        id: 'feature-fit',
        title: 'Feature Fit',
        items: [
          { label: 'Overview', value: 'Customer Journeys orchestrates multi-channel lifecycle campaigns with real-time triggers.' },
          { label: 'Use Cases', value: 'Loyalty retention plays; cart-abandon recovery; omnichannel promos.' },
          { label: 'Benefits', value: '+18% expected repeat purchases; unified customer journeys; faster segmentation.' },
          { label: 'Requirements', value: 'Marketing automation connector (available); SSO already configured.' },
        ],
        link: { label: 'View Documentation', href: 'https://docs.example.com/journeys' },
      },
      {
        id: 'outcomes',
        title: 'Expected Outcomes & Proof',
        items: [
          { label: 'Benefits', value: 'Increase loyalty revenue; reduce orchestration lead time; improve campaign conversion.' },
        ],
        bullets: [
          'Lumen Foods – +22% repeat revenue, unified loyalty journeys | https://example.com/case-lumen',
          'FreshCart – 30% faster campaign launches across channels | https://example.com/case-freshcart',
        ],
      },
      {
        id: 'health-signals',
        title: 'Health & Pipeline Signals',
        items: [
          { label: 'Weighted Pipeline', value: '$310K upsell in forecast' },
          { label: 'Buying Committee', value: '3 champions • VP Marketing (economic) • Martech lead (technical)' },
          { label: 'Next Milestone', value: 'May 3 QBR – loyalty expansion plan review' },
        ],
      },
      {
        id: 'actions',
        title: 'Next Steps',
        bullets: [
          'Introduce Journeys narrative during May 3 QBR (10:00 AM) with loyalty uplift benchmarks.',
          'Invite Marketing Ops lead to reference call; highlight retail peer wins.',
          'Draft upsell proposal aligned to FY25 retention goals and loyalty roadmap.',
        ],
        items: [
          { label: 'Owner', value: 'Relationship Manager' },
          { label: 'Timing', value: 'Prep deck and proof points by Apr 28.' },
        ],
      },
    ],
  },
  {
    id: 'alert-external-signal',
    title: 'Helios Energy',
    accountName: 'Helios Energy',
    featureName: 'Regulatory Compliance Suite',
    featureStatus: 'Beta (EU region)',
    opportunityValue: 110000,
    actionRecommendation: 'Reference EU expansion signal within 48h and offer compliance workshop.',
    matchType: 'External Signal',
    opportunityType: 'Solution Upgrade',
    priority: 'High',
    status: 'New',
    createdAt: '2025-11-11T12:15:00Z',
    matchConfidencePct: 83,
    isExternalSignal: true,
    externalSourceName: 'EnergyToday',
    summary: 'Series C expansion into EU triggers regulatory exposure; compliance suite fits.',
    badges: [
      { label: 'Act within 7 days', color: 'orange' },
      { label: 'Weighted Pipeline $110K', color: 'blue' },
      { label: 'Compliance Risk', color: 'red' },
    ],
    sections: [
      {
        id: 'signal-summary',
        title: 'Signal Summary',
        items: [
          { label: 'Headline', value: 'Helios announces EU expansion—requires new regulatory coverage.' },
          { label: 'Implication', value: 'Needs EU data residency, audit-ready logging, and compliance automation.', tone: 'negative' },
          { label: 'Eligibility', value: '🛈 Requires EU data center (available) • SOC2 in progress (negotiable).' },
          { label: 'Source', value: 'EnergyToday • Published 11 Nov 2025' },
        ],
      },
      {
        id: 'linked-needs',
        title: 'Linked Needs & Accounts',
        bullets: [
          'Need 55901 – “We must document EU regulatory controls before launch.”',
          'Need 53822 – “Legal requires immutable audit logs for EU data.”',
        ],
        collapsible: true,
        defaultOpen: true,
      },
      {
        id: 'feature-fit',
        title: 'Feature Fit',
        items: [
          { label: 'Overview', value: 'Compliance Suite automates policy enforcement, audit logging, and regulator reporting.' },
          { label: 'Use Cases', value: 'EU expansion compliance; regulator reporting; cross-border access control.' },
          { label: 'Requirements', value: 'Compliance contact (met); EU data residency (supported).' },
          { label: 'Warnings', value: 'SOC2 certification completes in Q3; prep customer advisory.' },
        ],
        link: { label: 'View Documentation', href: 'https://docs.example.com/compliance-suite' },
      },
      {
        id: 'outcomes',
        title: 'Expected Outcomes & Proof',
        items: [
          { label: 'Benefits', value: 'Avoid EU regulatory penalties; accelerate launch readiness; deliver auditor-friendly trails.' },
        ],
        bullets: [
          'SolarGrid Ltd. – Avoided €500K fines; 6-week rollout | https://example.com/case-solargrid',
          'Voltix Power – Completed EU compliance audits 2x faster | https://example.com/case-voltix',
        ],
      },
      {
        id: 'health-signals',
        title: 'Health & Pipeline Signals',
        items: [
          { label: 'Weighted Pipeline', value: '$110K upgrade opportunity' },
          { label: 'Opportunity Stage', value: 'Evaluation • closes in 28 days' },
          { label: 'Buying Committee', value: 'Legal (primary), Security Ops, EU GM' },
        ],
      },
      {
        id: 'actions',
        title: 'Next Steps',
        bullets: [
          'Reference expansion announcement within 48h; congratulate and propose compliance walkthrough.',
          'Offer compliance readiness workshop this week with legal/compliance stakeholders.',
          'Send SolarGrid case study before outreach; align on EU data residency timeline.',
        ],
        items: [
          { label: 'Owner', value: 'Account Owner' },
          { label: 'Timing', value: 'Engage within 2 business days.' },
        ],
      },
    ],
  },
]

export function listAlerts(): Promise<AlertVM[]> {
  return Promise.resolve([...alerts])
}

export function saveAlert(id: string): Promise<void> {
  alerts = alerts.map(a => (a.id === id ? { ...a, status: 'Saved' } : a))
  return Promise.resolve()
}

export function dismissAlert(id: string): Promise<void> {
  alerts = alerts.map(a => (a.id === id ? { ...a, status: 'Dismissed' } : a))
  return Promise.resolve()
} 
